import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios"; import { handleAuthError } from "../../utils";
import withAuth from "../withAuth";
import { 
  Col, 
  Container, 
  Row, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  Form, 
  Label, 
  Input, 
  FormFeedback, 
  Card, 
  CardBody, 
  Badge,
  Spinner
} from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { baseUrl } from '../../Network';
import Select from "react-select";
import { getLabelsForIds, getLevelLabels, transformCoursesToSelectOptions } from "../../utils";
import TeacherAssignmentModal from "./TeacherAssignmentModal";
import TeacherAnalyticsModal from "./TeacherAnalyticsModal";

const ManageAutoAssignment = () => {
  document.title = "Manage Auto Assignment | RYD Admin";

  const [loading, setLoading] = useState(true);
  const [assignments, setAssignments] = useState([]);
  const [packages, setPackages] = useState([]);
  const [assignmentData, setAssignmentData] = useState({});
  const [level, setLevel] = useState({});
  const [levelId, setLevelId] = useState({});
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [cohorts, setCohort] = useState([]);
  const [multiIDs, setMultiIDs] = useState([]);
  const [multiTargetIDs, setMultiTargetIDs] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [availableHr, setAvailableHr] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [selectedCohort, setSelectedCohort] = useState("none");
  const [selectedTimezone, setSelectedTimezone] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [levelOptions, levelOptionsChange] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [isAssigning, setIsAssigning] = useState(false);

  useEffect(() => {
    fetchCohort();
  }, [modal]);

  useEffect(() => {
    if (selectedCohort !== "none") {
      fetchAssignments();
      fetchPackage();
    }
  }, [selectedCohort]);

  const fetchAssignments = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/admin/teacher/assignments/${selectedCohort}`);
      setAssignments(response.data.data);
      setLoading(false);
    } catch (error) { handleAuthError(error)
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const fetchPackage = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/admin/package/all`);
      setPackages(response.data.data);
      setLoading(false);
    } catch (error) { handleAuthError(error)
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const fetchCohort = async () => {
    try {
      const response = await axios.get(`${baseUrl}/admin/cohort/all`);
      setCohort(response?.data?.data);
      setLoading(false);
    } catch (error) { handleAuthError(error)
      setLoading(false);
      console.error("Error:", error);
    }
  };

  const processAutoAssignment = async () => {
    //performing group actions
    try {
      if (multiIDs.length > 0) {
        const response = await axios.post(`${baseUrl}/admin/teacher/auto-assignment/${selectedCohort}`, { id: multiIDs });
        if (!response.data.status) {
          toast.error(response.data.message);
        } else {
          toast.success(response.data.message);
          await fetchAssignments()
          return response
        }

      } else {
        toast.error("Please, select at least 1 teacher to perform action")
        setShowAssignmentModal(false)
      }
    } catch (e) { handleAuthError(e)
      toast.error("Reload this page and try again")
    }
  }

  const handleAnalytics = (teacher) => {
    setSelectedTeacher(teacher);
  };

  const toggle = () => {
    setModal(!modal);
  };

  const toggle2 = () => {
    setModal2(!modal2);
  };

  const handleAssignmentClick = (Assignment) => {
    if (Assignment) {
      setAssignmentData(Assignment);
      setIsEdit(true);
      toggle();
    }
  };

  const handleLevels = (Assignment) => {
    if (Assignment) {
      setLevel(Assignment.levels);
      setLevelId(Assignment.id);
      toggle2();
      const levelLabels = getLevelLabels(Assignment.levels, packages);
      levelOptionsChange(levelLabels)
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      day: assignmentData.day || "",
      dayHr: assignmentData.dayHr || "",
      weekHr: assignmentData.weekHr || "",
      students: assignmentData.student || "",
      break: assignmentData.break || "",
      off: assignmentData.dayOff || "",
    },
    validationSchema: Yup.object({
      day: Yup.string().required("Day is required"),
      dayHr: Yup.string().required("Day Hours is required"),
      weekHr: Yup.string().required("Week Hours is required"),
      students: Yup.string().required("Students is required"),
      break: Yup.string().required("Break is required"),
      off: Yup.string().required("Off is required"),
    }),
    onSubmit: async (values) => {
      try {
        const newAssignment = {
          day: values.day,
          dayHr: values.dayHr,
          weekHr: values.weekHr,
          student: values.students,
          break: values.break,
          dayOff: values.off,
        };

        const response = await axios.put(
          `${baseUrl}/admin/teacher/assignment/edit/${assignmentData.id}`,
          newAssignment
        );

        toast.success("Assignment updated successfully");
        fetchAssignments()
        toggle();
        setModal(false)

      } catch (error) { handleAuthError(error)
        console.error("Error:", error);
      }
    },
  });

  const metricsData = [
    { title: "Paid Children", count: assignments?.stats?.paidPrograms, statusColor: "success" },
    { title: "Assigned Children", count: assignments?.stats?.assignedPrograms, statusColor: "danger" },
    { title: "Unassigned Children", count: assignments?.stats?.unassignedPrograms, statusColor: "primary" },
    { title: "Available Hour ", count: availableHr, statusColor: "secondary" },
  ]

  const addHours = (no) => {
    setAvailableHr(prev => prev + no);
  };

  const addMultipleHours = (val) => {
 if(val){
  const totalAvailableHours = calculateTotalAvailableHours(assignments.teachers);
  setAvailableHr(totalAvailableHours.totalAvailableHours)
 }else{
  setAvailableHr(0)
 }
  };

  const subtractHours = (no) => {
    setAvailableHr(prev => Math.max(0, prev - no));
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allIDs = assignments.teachers.map(t => t.id);
      setMultiIDs(allIDs);
      addMultipleHours(true);
      toast.warn("All items have been added to the action list.");
    } else {
      setMultiIDs([])
      addMultipleHours(false);
      toast.error("All items have been removed from the action list.");
    }
  };

  const getLevelFilter = () => {
    const lF = levelOptions.map((opt) => opt.value)
    return { levels: lF };
  }

  const updateLevels = async (id) => {
    try {
      setLoading2(true);
      const levels = getLevelFilter()
      const response = await axios.put(
        `${baseUrl}/admin/teacher/level/update/${id}`,
        levels
      );
      toast.success("Teacher levels updated successfully");
      setLoading2(false);
      toggle2();
      fetchAssignments();
    } catch (error) { handleAuthError(error)
      console.error("Error:", error);
    }
  };

  const selectOptions = transformCoursesToSelectOptions(packages);

const calculateTotalAvailableHours = (teachers) => {
  if (!teachers || !Array.isArray(teachers)) {
    return { totalAvailableHours: 0 };
  }

  const totalAvailableHours = teachers.reduce((sum, teacher) => {
    const hours = Math.max(0, Number(teacher.availableWeekHr) || 0);
    return sum + hours;
  }, 0);


  return {
    totalAvailableHours: Math.round(totalAvailableHours * 100) / 100
  };
};

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Manage Auto Assignment" />
          <Row>
            <Col lg="12">
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="mb-3">
                    <h5 className="card-title">
                      Teachers List{" "}
                      <span className="text-muted fw-normal ms-2">
                        ({assignments?.teachers?.length})
                      </span>
                    </h5>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                    <div>
                      <select className={'form-control'} onChange={(e) => {
                        if (Number(e.target.value) === 0) {
                          window.location.reload()
                        } else {
                          setSelectedCohort(e.target.value)
                        }
                      }}>
                        <option value={"none"}>All Cohorts</option>
                        {cohorts && cohorts.map((d, i) => <option key={i}
                          value={d.id}>{d.title}</option>)}
                      </select>
                    </div>
                    <div>
                      <Link
                        to="#"
                        className="ms-2 btn btn-primary"
                        onClick={() => setShowAssignmentModal(true)}
                        disabled={selectedCohort === "none" || isAssigning}
                      >
                        {isAssigning ? (
                          <>
                            <Spinner size="sm" className="me-2" />
                            Assigning...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-robot me-2"></i>
                            Auto Assign
                          </>
                        )}
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl="12" style={{ overflow: 'scroll', width: '98%' }}>

                  {selectedCohort !== "none" && <>
                    <Row>
                      {metricsData.map((card, index) => (
                        <Col key={index} xl={3} md={6}>
                          <Card className="card-h-100">
                            <CardBody>
                              <h6 className="mb-3">{card.title}</h6>
                              <div className={"badge bg-" + card.statusColor + "-subtle text-" + card.statusColor + " mb-3"} style={{ fontSize: "25px", padding: "10px" }}>
                                {card.count}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </>}

                  {loading ? (
                    <div className="text-center mt-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : assignments.length === 0 ? (
                    <div className="text-center mt-5">
                      <h3>Select a Cohort to Analyze</h3>
                    </div>
                  ) : (
                    <div className="table-responsive mt-4 shadow rounded" style={{ backgroundColor: '#f9f9fb' }}>
                    <table className="table align-middle table-hover">
                      <thead className="bg-primary text-white" style={{ borderRadius: '12px' }}>
                        <tr>
                          <th>
                            <div style={{ width: 60 }}>
                              <input
                                type="checkbox"
                                onChange={handleSelectAllChange}
                                className="form-check-input me-1"
                              />
                              All
                            </div>
                          </th>
                          <th>Name</th>
                          <th>Timezone</th>
                          <th>Days</th>
                          <th>Day(hr)</th>
                          <th>Week(hr)</th>
                          <th>Students</th>
                          <th>Break</th>
                          <th>Off</th>
                          <th>Available(hr)</th>
                          <th>Excess(hr)</th>
                          <th>Assigned</th>
                          <th>Levels</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {assignments?.teachers?.map((Assignment, index) => (
                          <tr
                            key={index}
                            className={`align-middle ${index % 2 === 0 ? 'bg-white' : 'bg-light'}`}
                            style={{ borderBottom: '1px solid #e0e0e0' }}
                          >
                            <td>
                              <div style={{ width: 60 }}>
                                <input
                                  type="checkbox"
                                  className="form-check-input me-2"
                                  checked={multiIDs.includes(Assignment.id)}
                                  onClick={() => {
                                    if (multiIDs.includes(Assignment.id)) {
                                      setMultiIDs(multiIDs.filter(i => i !== Assignment.id));
                                      subtractHours(Assignment.availableWeekHr);
                                      toast.error(`${Assignment.name} removed from action list.`);
                                    } else {
                                      setMultiIDs([...multiIDs, Assignment.id]);
                                      addHours(Assignment.availableWeekHr);
                                      toast.warn(`${Assignment.name} added to action list.`);
                                      console.log("here")
                                    }
                                  }}
                                />
                                {index + 1}
                              </div>
                            </td>
                            <td>{Assignment.name}</td>
                            <td>{Assignment.timezone || 'N/A'}</td>
                            <td>{Assignment.day}</td>
                            <td>{Assignment.dayHr}</td>
                            <td>{Assignment.weekHr}</td>
                            <td>{Assignment.student}</td>
                            <td>{Assignment.break}</td>
                            <td>{Assignment.dayOff || '-'}</td>
                            <td>
                              <span className="badge bg-success">{Assignment.availableWeekHr || 0}</span>
                            </td>
                            <td>
                              <span className={`badge ${Assignment.excess ? 'bg-danger' : 'bg-secondary'}`}>
                                {Assignment.availableWeekHr < 0 ? Math.abs(Assignment.availableWeekHr) : 0}
                              </span>
                            </td>
                            <td>{Assignment.assignedCount || 0}</td>
                            <td>{getLabelsForIds(Assignment.levels, selectOptions)}</td>
                            <td>
                              <div className=" gap-2 justify-content-center">
                                <button
                                  title="View Analytics"
                                  onClick={() => handleAnalytics(Assignment)}
                                  className="btn btn-outline-info btn-sm d-flex mb-2"
                                >
                                  <i className="mdi mdi-chart-box-outline me-1"></i> View
                                </button>
                                <button
                                  title="Update Assignment"
                                  onClick={() => handleAssignmentClick(Assignment)}
                                  className="btn btn-outline-success btn-sm d-flex mb-2"
                                >
                                  <i className="mdi mdi-pencil-outline me-1"></i> Edit
                                </button>
                                <button
                                  onClick={() => handleLevels(Assignment)}
                                  className="btn btn-outline-primary btn-sm mb-2"
                                >
                                  Levels
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  
                  )}

                  <Modal isOpen={modal2} toggle={toggle2}>
                    <ModalHeader toggle={toggle2}>
                      Allowed Package
                    </ModalHeader>
                    <ModalBody>
                      <Form onSubmit={validation.handleSubmit}>
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Level</Label>
                              <Select isMulti options={selectOptions} type="select"
                                name="byLevel"
                                onChange={levelOptionsChange}
                                value={levelOptions}
                                invalid={
                                  validation.touched.byLevel &&
                                  validation.errors.byLevel
                                } />
                              <FormFeedback type="invalid">
                                {validation.errors.byLevel}
                              </FormFeedback>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                disabled={loading2}
                                onClick={() => updateLevels(levelId)}
                                className="btn btn-primary save-user">
                                {loading2 ? 'Updating...' : 'Update Coupon'}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>
                      {assignmentData.name}Assignment
                    </ModalHeader>
                    <ModalBody>
                      <Form onSubmit={validation.handleSubmit}>
                        <Row>
                          <Col xs={12}>
                            <Row>
                              <Col xs={12} md={6}>
                                <div className="mb-3">
                                  <Label className="form-label">Day</Label>
                                  <Input
                                    name="day"
                                    type="text"
                                    placeholder="Day"
                                    onChange={validation.handleChange}
                                    value={validation.values.day}
                                    invalid={validation.errors.day}
                                  />
                                  {validation.errors.day && (
                                    <FormFeedback>{validation.errors.day}</FormFeedback>
                                  )}
                                </div>
                              </Col>
                              <Col xs={12} md={6}>
                                <div className="mb-3">
                                  <Label className="form-label">Day (hr)</Label>
                                  <Input
                                    name="dayHr"
                                    type="text"
                                    placeholder="Day Hours"
                                    onChange={validation.handleChange}
                                    value={validation.values.dayHr}
                                    invalid={validation.errors.dayHr}
                                  />
                                  {validation.errors.dayHr && (
                                    <FormFeedback>{validation.errors.dayHr}</FormFeedback>
                                  )}
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <div className="mb-3">
                                  <Label className="form-label">Week (hr)</Label>
                                  <Input
                                    name="weekHr"
                                    type="text"
                                    placeholder="Week Hours"
                                    onChange={validation.handleChange}
                                    value={validation.values.weekHr}
                                    invalid={validation.errors.weekHr}
                                  />
                                  {validation.errors.weekHr && (
                                    <FormFeedback>{validation.errors.weekHr}</FormFeedback>
                                  )}
                                </div>
                              </Col>
                              <Col xs={12} md={6}>
                                <div className="mb-3">
                                  <Label className="form-label">Students</Label>
                                  <Input
                                    name="students"
                                    type="text"
                                    placeholder="Students"
                                    onChange={validation.handleChange}
                                    value={validation.values.students}
                                    invalid={validation.errors.students}
                                  />
                                  {validation.errors.students && (
                                    <FormFeedback>{validation.errors.students}</FormFeedback>
                                  )}
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <div className="mb-3">
                                  <Label className="form-label">Break</Label>
                                  <Input
                                    name="break"
                                    type="text"
                                    placeholder="Break"
                                    onChange={validation.handleChange}
                                    value={validation.values.break}
                                    invalid={validation.errors.break}
                                  />
                                  {validation.errors.break && (
                                    <FormFeedback>{validation.errors.break}</FormFeedback>
                                  )}
                                </div>
                              </Col>
                              <Col xs={12} md={6}>
                                <div className="mb-3">
                                  <Label className="form-label">Off</Label>
                                  <Input
                                    name="off"
                                    type="text"
                                    placeholder="Off"
                                    onChange={validation.handleChange}
                                    value={validation.values.off}
                                    invalid={validation.errors.off}
                                  />
                                  {validation.errors.off && (
                                    <FormFeedback>{validation.errors.off}</FormFeedback>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-primary save-Assignment"
                              >
                                Update Assignment
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>

                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      
      {/* Teacher Assignment Modal */}
      {showAssignmentModal && (
        <TeacherAssignmentModal 
          onClose={() => setShowAssignmentModal(false)}
          onAssign={processAutoAssignment}
        />
      )}

      {/* Teacher Analytics Modal */}
      {selectedTeacher && (
        <TeacherAnalyticsModal 
          teacher={selectedTeacher}
          onClose={() => setSelectedTeacher(null)}
        />
      )}

      <ToastContainer />
    </React.Fragment>
  );
};

export default withAuth(ManageAutoAssignment);